import { Fragment } from "react";

export default function CartSummery({ data }) {
  return (
    <Fragment>
      <div className="coursePriceSection cartSummary">
        <div className="card bg-light-white shadow cartSummaryCard">
          <div className="card-body">
            <h3 className="cartSummaryTitle">Order Summary</h3>

            <div className="cartSummaryCourse">
              <img src={data.cover} className="cartSummaryThumb rounded" alt={data.name} />
              <div>
                <h5 className="course-title cartSummaryName">{data.name}</h5>
                <p className="author-name mb-0">By {data.teacher}</p>
              </div>
            </div>

            {data.short_details && (
              <p className="course-description cartSummaryDesc">{data.short_details}</p>
            )}

            <hr />

            <div className="d-flex justify-content-between cartSummaryRow">
              <span>Price</span>
              <span>{data.currency_code}{data.course_price}</span>
            </div>
            <div className="d-flex justify-content-between cartSummaryRow text-muted">
              <span>Tax</span>
              <span>Calculated at payment</span>
            </div>

            <hr />

            <div className="d-flex justify-content-between cartSummaryTotal">
              <span>Total</span>
              <span className="orangeRed">{data.currency_code}{data.course_price}</span>
            </div>

            <ul className="cartSummaryPerks">
              <li><i className="fas fa-redo-alt me-2"></i>30-day money-back guarantee</li>
              <li><i className="fas fa-infinity me-2"></i>Full lifetime access</li>
              <li><i className="fas fa-certificate me-2"></i>Certificate of completion</li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
